import React from 'react';
import YoutubeNavbar from './YoutubeNavbar';
import YoutubeHero from './YoutubeHero';
import YoutubeMakeItWork from './YoutubeMakeItWork';
import YoutubeFeatures from './YoutubeFeatures';
import YoutubeFooter from './YoutubeFooter';
import { motion } from 'framer-motion';
import './YoutubePromotion.css';
import LastComponent from '../Services/RightsManagement/LastComponent';

const YoutubePromotion = () => {
  return (
    <motion.div 
      className="youtube-promotion-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* <YoutubeNavbar /> */}
      <YoutubeHero />
      <YoutubeMakeItWork />
      <YoutubeFeatures />
      <LastComponent
        headingbefore="Get Your Music on YouTube with FTTunes"
        mark=""
        detail="Explore Plans"
      />
      {/* <YoutubeCTA /> */}
      {/* <YoutubeFooter /> */}
    </motion.div>
  );
};

export default YoutubePromotion;
